import React from 'react';
import { SceneObjectBase } from '../../core/SceneObjectBase.js';
import { SceneVariableValueChangedEvent } from '../types.js';
import { AdHocFilterSet } from './AdHocFiltersSet.js';
import { VariableHide } from '@grafana/schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const _AdHocFiltersVariable = class extends SceneObjectBase {
  static create(state) {
    var _a;
    return new _AdHocFiltersVariable({
      type: "adhoc",
      hide: VariableHide.hideLabel,
      name: (_a = state.name) != null ? _a : "Filters",
      set: new AdHocFilterSet(__spreadProps(__spreadValues({}, state), {
        applyMode: "manual"
      }))
    });
  }
  constructor(state) {
    var _a;
    super(__spreadProps(__spreadValues({}, state), {
      filterExpression: (_a = state.filterExpression) != null ? _a : renderFilters(state.set.state.filters)
    }));
    this.addActivationHandler(() => {
      this._subs.add(
        this.state.set.subscribeToState((newState, prevState) => {
          if (newState.filters !== prevState.filters) {
            this._updateFilterExpression(newState.filters, true);
          }
        })
      );
      this._updateFilterExpression(this.state.set.state.filters, false);
    });
  }
  getValue() {
    return this.state.filterExpression;
  }
  _updateFilterExpression(filters, publishEvent) {
    let expr = renderFilters(filters);
    if (expr === this.state.filterExpression) {
      return;
    }
    this.setState({ filterExpression: expr });
    if (publishEvent) {
      this.publishEvent(new SceneVariableValueChangedEvent(this), true);
    }
  }
};
let AdHocFiltersVariable = _AdHocFiltersVariable;
AdHocFiltersVariable.Component = ({ model }) => {
  return /* @__PURE__ */ React.createElement(AdHocFilterSet.Component, {
    model: model.state.set
  });
};
function renderFilters(filters) {
  let expr = "";
  for (const filter of filters) {
    expr += `${renderFilter(filter)},`;
  }
  if (expr.length > 0) {
    expr = expr.slice(0, -1);
  }
  return expr;
}
function renderFilter(filter) {
  let value = "";
  if (filter.operator === "=~" || filter.operator === "!~\xA8") {
    value = escapeLabelValueInRegexSelector(filter.value);
  } else {
    value = escapeLabelValueInExactSelector(filter.value);
  }
  return `${filter.key}${filter.operator}"${value}"`;
}
function escapeLabelValueInExactSelector(labelValue) {
  return labelValue.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/"/g, '\\"');
}
function escapeLabelValueInRegexSelector(labelValue) {
  return escapeLabelValueInExactSelector(escapeLokiRegexp(labelValue));
}
const RE2_METACHARACTERS = /[*+?()|\\.\[\]{}^$]/g;
function escapeLokiRegexp(value) {
  return value.replace(RE2_METACHARACTERS, "\\$&");
}

export { AdHocFiltersVariable, escapeLabelValueInExactSelector, escapeLabelValueInRegexSelector };
//# sourceMappingURL=AdHocFiltersVariable.js.map
